import axios from 'axios'
import { MetadataProcedure } from '../types/procedureArianeModels'
import { ListeProceduresResponseModel } from '../../../modules/listeProcedures/types/filtresListeProceduresModel'
import { ReactivationProcedurePayload } from '../components/PopinReactivationModel'

export const relanceManuelle = (procedureId: string): Promise<MetadataProcedure> =>
	axios(`/api/procedure/relance/${procedureId}`).then((response) => response.data)

export const cancelProcedure = (procedureId: string): Promise<MetadataProcedure> =>
	axios(`/api/procedure/cancel/${procedureId}`).then((response) => response.data)

export const getMetadata = (procedureId: string): Promise<MetadataProcedure> =>
	axios(`/api/procedure/${procedureId}/metadata`).then((response) => response.data)

export const reactivateProcedure = (data: ReactivationProcedurePayload): Promise<ListeProceduresResponseModel> =>
	axios.post('/api/procedure/reactivate', { ...data }).then((response) => response.data)